export const Packages = [
  {
    id: 1,
    name: "Paket 100 Mbps",
    speed: "100 Mbps",
    price: "Rp 140.600 / bulan",
    devices: "Harga Belum Termasuk PPN",
    badge: "Lite",
    features: ["Internet unlimited", "Pembayaran Mudah", "Support 24 Jam"]
  },
  {
    id: 2,
    name: "Paket 150 Mbps",
    speed: "150 Mbps",
    price: "Rp 239.189 / bulan",
    devices: "Harga Belum Termasuk PPN",
    badge: "Plus",
    featured: true,
    features: ["Internet unlimited", "Pembayaran Mudah", "Support 24 Jam"]
  },
  {
    id: 3,
    name: "Paket 200 Mbps",
    speed: "200 Mbps",
    price: "Rp 288.198 / bulan",
    devices: "Harga Belum Termasuk PPN",
    badge: "Pro",
    features: ["Internet unlimited", "Pembayaran Mudah", "Support 24 Jam"]
  },
  {
    id: 4,
    name: "Paket 300 Mbps",
    speed: "300 Mbps",
    price: "Rp 365.315 / bulan",
    devices: "Harga Belum Termasuk PPN",
    badge: "Pro Ultra",
    features: ["Internet unlimited", "Pembayaran Mudah", "Support 24 Jam"]
  },
];
